import { Fragment, useState } from "react";
import { champPath } from "../misc/Static";
import Champ from "../images/Champ";
import MatchRow from "./MatchRow";
import MatchRowTiny from "./MatchRowTiny";
import MatchChart from "./MatchChart";
import Tip from "../misc/Tip";
import styles from "./MatchDetails.module.css";

export const MatchDetails = ({ region, order, match, calc, width }) => {
  const [active, setActive] = useState(0);
  const tabs = ["Overview", "Gold", "Team Gold", "Team Gold Δ", "XP", "CS"];
  const clickTab = (e) => {
    setActive(parseInt(e.target.getAttribute("data-id")));
  };
  return (
    <div className={styles["winner" + (match.winner[0] ? 0 : 1)]}>
      {width !== "xsmall" && width !== "tiny" && (
        <div className={styles.matchtabs}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={active === i ? styles.active : ""}
              onClick={(e) => clickTab(e)}
              data-id={i}
            >
              {tab}
            </div>
          ))}
        </div>
      )}
      {active === 0 && (
        <>
          {order.map((team, i) => (
            <div key={"team" + i} className={styles["team" + i]}>
              {i === 1 && (
                <div className={styles["tally_" + width]}>
                  {width !== "tiny" && width !== "xsmall" && (
                    <div className={styles.blueobjectives}>
                      <Tip name="bluetowers">
                        <img
                          src="https://cdn5.xdx.gg/icons/turret1.webp"
                          alt="Blue Turrets"
                        />
                        {calc.tower[0]}
                      </Tip>
                      <Tip name="blueinhibs">
                        <img
                          src="https://cdn5.xdx.gg/icons/inhib1.webp"
                          alt="Blue Inhibs"
                        />
                        {calc.inhib[0]}
                      </Tip>
                      <Tip name="bluedragons">
                        <img
                          src="https://cdn5.xdx.gg/icons/dragon1.webp"
                          alt="Blue Dragons"
                        />
                        {calc.dragon[0]}
                      </Tip>
                      <Tip name="blueherald">
                        <img
                          src="https://cdn5.xdx.gg/icons/rift1.webp"
                          alt="Blue Heralds"
                        />
                        {calc.herald[0]}
                      </Tip>
                      <Tip name="bluebarons">
                        <img
                          src="https://cdn5.xdx.gg/icons/baron1.webp"
                          alt="Blue Barons"
                        />
                        {calc.baron[0]}
                      </Tip>
                    </div>
                  )}
                  <div className={styles.bluekda}>
                    <img src="https://cdn5.xdx.gg/icons/score.webp" alt="kda" />
                    {calc.kills[0]} / {calc.deaths[0]} / {calc.assists[0]}
                  </div>
                  <div className={styles.tallymid}></div>
                  <div className={styles.redkda}>
                    <img src="https://cdn5.xdx.gg/icons/score.webp" alt="kda" />
                    {calc.kills[1]} / {calc.deaths[1]} / {calc.assists[1]}
                  </div>
                  {width !== "tiny" && width !== "xsmall" && (
                    <div className={styles.redobjectives}>
                      <Tip name="redbarons">
                        <img
                          src="https://cdn5.xdx.gg/icons/baron2.webp"
                          alt="Red Barons"
                        />
                        {calc.baron[1]}
                      </Tip>
                      <Tip name="redherald">
                        <img
                          src="https://cdn5.xdx.gg/icons/rift2.webp"
                          alt="Red Heralds"
                        />
                        {calc.herald[1]}
                      </Tip>
                      <Tip name="reddragons">
                        <img
                          src="https://cdn5.xdx.gg/icons/dragon2.webp"
                          alt="Red Dragons"
                        />
                        {calc.dragon[1]}
                      </Tip>
                      <Tip name="redinhibs">
                        <img
                          src="https://cdn5.xdx.gg/icons/inhib2.webp"
                          alt="Red Inhibs"
                        />
                        {calc.inhib[1]}
                      </Tip>
                      <Tip name="redtowers">
                        <img
                          src="https://cdn5.xdx.gg/icons/turret2.webp"
                          alt="Red Towers"
                        />
                        {calc.tower[1]}
                      </Tip>
                    </div>
                  )}
                </div>
              )}
              <div className={styles["t_" + width]}>
                <div className={styles.t_bans}>{match.bans && <>BANS:</>}</div>
                <div className={styles.t_bans2}>
                  {team.map((p, j) => (
                    <Fragment key={j}>
                      {match.bans && match.bans[p] > 0 && (
                        <a
                          href={
                            "https://lolalytics.com/lol/" +
                            champPath(match.bans[p]) +
                            "/build/"
                          }
                        >
                          <Champ type="champ24b" id={match.bans[p]} />
                        </a>
                      )}
                    </Fragment>
                  ))}
                </div>
                {width !== "xsmall" && width !== "tiny" && (
                  <>
                    <div>TIER</div>
                    <div className={styles.t_items}>ITEMS</div>
                    <div>KDA</div>
                    <div className={styles.t_icons}>
                      <img
                        src="https://cdn5.xdx.gg/icons/score.webp"
                        alt="Damage"
                      />
                    </div>
                    <div>WARDS</div>
                    <div className={styles.t_icons}>
                      <img
                        src="https://cdn5.xdx.gg/icons/gold.webp"
                        alt="Gold"
                      />
                    </div>
                    <div className={styles.t_icons}>
                      <img
                        src="https://cdn5.xdx.gg/icons/minion.webp"
                        alt="Minion"
                      />
                    </div>
                  </>
                )}
              </div>
              {width === "tiny" &&
                team.map((p, j) => (
                  <MatchRowTiny
                    key={"player" + j}
                    match={match}
                    calc={calc}
                    region={region}
                    p={p}
                    width={width}
                  />
                ))}
              {width !== "tiny" &&
                team.map((p, j) => (
                  <MatchRow
                    key={"player" + j}
                    match={match}
                    calc={calc}
                    region={region}
                    p={p}
                    width={width}
                  />
                ))}
            </div>
          ))}
        </>
      )}
      {active > 0 && (
        <MatchChart
          chart={active}
          match={match}
          region={region}
          order={order}
          width={width}
        />
      )}
    </div>
  );
};

export default MatchDetails;
